/* eslint-disable */

//url参数序列化
export function urlQuerySerialize (parmas) {
  const resStr = [];
  
  if (Object.prototype.toString.call(parmas) === '[object Object]') {
    Object.keys(parmas).forEach(function (key) {
      resStr.push(encodeURIComponent(key) + '=' + encodeURIComponent(parmas[key]));
    });
  }
  
  return resStr.join('&');
}

//url参数解析
export function urlQueryParse (str) {
  const resObj = {};
  let arr = [];
  
  if (Object.prototype.toString.call(str) === '[object String]') {
    arr = str.split('&');
    arr.forEach(item => {
      const obj = item.split('=');
      resObj[decodeURIComponent(obj[0])] = decodeURIComponent(obj[1]);
    });
  }
  
  return resObj;
}

//时间格式化 "2019-07-17"
export function dateFormater (date, separator) {
  let res = '';
  separator = separator ? separator : '-';
  if (date instanceof Date) {
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    
    month = month < 10 ? '0' + month : month;
    day = day < 10 ? '0' + day : day;
    res = year + separator + month + separator + day;
  }
  
  return res;
}

//时间格式化  "2019-07-17 17:54:28"
export function timeFormater (date, separator) {
  let res = '';
  separator = separator ? separator : '-';
  if (date instanceof Date) {
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();
    
    month = month < 10 ? '0' + month : month;
    day = day < 10 ? '0' + day : day;
    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;
    
    res = year + separator + month + separator + day
      + ' ' + hours + ':' + minutes + ':' + seconds;
  }
  
  return res;
}

//获取秒数
export function getTimes (date) {
  let res = '';
  if (date instanceof Date) {
    res = Math.ceil(date.getTime() / 1000);
  }
  
  return res;
}

//把秒转换为Date
export function secondToDate (value) {
  return new Date(value * 1000);
}

//数字转为千分位字符  无兼容性
export function numToThousandBit (value) {
  value *= 1;
  value += '';
  value = value.split('.');
  
  if (!value[1]) {
    value[1] = '';
  }
  
  let res = '';
  
  //整数部分
  res = value[0].split('').reverse().reduce((prev, next, index) => {
    return ((index % 3) ? next : (next + ',')) + prev;
  });
  
  //小数部分
  if (value[1]) {
    const floatArr = value[1].split('');
    res += '.' +
      floatArr.reduce((prev, next, index) => {
        const myIndex = index + 1;
        return prev + ((myIndex % 3 === 0 && myIndex < floatArr.length) ? (next + ',') : next);
      });
  }
  
  return res;
}

//数组排序：按对象的key排序(升序)
export function sortByKey (arr, keyName) {
  let resArr = arr.concat([]);
  arr.sort((obj1, obj2) => {
    return obj1[keyName] - obj2[keyName];
  });
  return resArr;
}

//数组去重  兼容到ie9
export function distinct (arr) {
  return arr.filter((val, index) => arr.indexOf(val) === index);
}

//获取随机整数: [min, max]  Math.random() [0, 1)
export function getRandomNum (min, max) {
  return Math.round(Math.random() * (max - min) + min);
}

//element-ui 日期选择器 快捷键
export function pickerOptions () {
  return {
    shortcuts: [{
      text: '最近一周',
      onClick (picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近一个月',
      onClick (picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近三个月',
      onClick (picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        picker.$emit('pick', [start, end]);
      }
    }]
  };
}

//------------flkj-------------------

// 获取时间段
export function getTimeQuantum (date) {
  let startTime = '';
  let endTime = '';
  if (date) {
    startTime = dateFormater(date[0]) + ' 00:00:00';
    endTime = dateFormater(date[1]) + ' 23:59:59';
  }
  
  return [startTime, endTime];
}

export function encryptionPhoneNumber (val) {
  if (!val) {
    return val;
  }
  
  val += '';
  return val.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
}

export function encryptionAddress (val) {
  if (!val) {
    return val;
  }
  
  val += '';
  if (val.lastIndexOf('市') !== -1) {
    return val.slice(0, (val.lastIndexOf('市') + 1)) + '***************';
  } else {
    return val;
  }
}

export function trimParseToNull (val) {
  if (val === '' || val === null || val === undefined) {
    return null;
  }
  
  return val;
}

export function paramsToNumber (val) {
  let result = trimParseToNull(val);
  
  if (result) {
    result = Number(val);
  }
  
  return result;
}

// 价格格式化
export function priceRule (value) {
  if (typeof (value) === 'undefined' || value === null || value === '' || value === undefined) {
    return '—';
  } else {
    return '￥' + value.toFixed(2);
  }
}
